import React, { useState } from 'react';
import { toast } from 'react-toastify';

const MyForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        trackingId: '',
        message: '',
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.id]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setFormData({
            name: '',
            email: '',
            phone: '',
            trackingId: '',
            message: '',
        });
        toast.success('Your message has been sent successfully.');
    };

    return (
        <form id="myForm" onSubmit={handleSubmit}>
            <div className="row">
                <div className="col-lg-6 col-md-6 col-12">
                    <input
                        id="name"
                        className="fild"
                        type="text"
                        placeholder="Your Name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="col-lg-6 col-md-6 col-12">
                    <input
                        id="email"
                        className="fild"
                        type="email"
                        placeholder="Email Address"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="col-lg-6 col-md-6 col-12">
                    <input
                        id="phone"
                        className="fild"
                        type="text"
                        placeholder="Your Number"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="col-lg-6 col-md-6 col-12">
                    <input
                        id="trackingId"
                        className="fild"
                        type="text"
                        placeholder="Enter your tracking id"
                        value={formData.trackingId}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="col-12">
                    <textarea
                        id="message"
                        className="fild fild-textarea"
                        placeholder="Write Message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="col-12">
                    <button type="submit" className="theme-btn">Send Us Messages <i className="ti-angle-right"></i></button>
                </div>
            </div>
        </form>
    );
};

export default MyForm;
